import { Directive, Input, ElementRef, ViewChild, Renderer2 } from '@angular/core';

@Directive({ selector: '[conversationAssessorDirective]' })
export class ConversationAssessorDirective {

    // controla o container do loading
    private ContainerAgentTyping: any;

    // controla a entrada e saida do loading
    private AgentTyping: any;

    private DOMObserver;

    private conversationContainer;

    constructor(
        private ElRef: ElementRef,
        private _r: Renderer2
    ) { }

    ngOnInit() {
        // get elements to manipule in DOM
        this.getElements();
        // Start DOM observer
        this.containerScrollObserver().observe(this.conversationContainer, { childList: true });
    }

    /**
     * executa sempre q receber uma atualizacao de status,
     * vindo sempre a ultima msg do assessor recebida
     */
    @Input('assessorStatus') set assessorStatus(status: any) {
        if (status) {

            this.checkParent();

            switch (status) {
                case 'AgentDisconnect':
 
                    break;
                case 'AgentNotTyping':
                    this._r.removeClass(this.AgentTyping, 'on-entry');
                    break;
                case 'AgentTyping':
                    this._r.addClass(this.AgentTyping, 'on-entry');
                    break;
                case 'ChasitorSessionData':

                    break;
                case 'ChatEnded':
                    this._r.removeClass(this.AgentTyping, 'on-entry');
                    break;
                case 'ChatEstablished':

                    break;
                case 'ChatMessage':
                    this._r.removeClass(this.AgentTyping, 'on-entry');
                    break;
                case 'ChatRequestSuccess':

                    break;
                case 'ChatTransferred':

                    break;
                case 'CustomEvent':
                    this.managementCustomEvents();
                    break;
                case 'NewVisitorBreadcrumb':

                    break;
                case 'QueueUpdate':

                    break;
                default:

                    break;
            }
        }
    }

    // custom Status obj
    @Input('customEvent') private customEvent

    // recupera do dom os elementos 
    getElements() {
        this.ContainerAgentTyping = this.ElRef.nativeElement.querySelector('#ContainerAgentTyping');
        this.AgentTyping = this.ElRef.nativeElement.querySelector('#AgentTyping');
        this.conversationContainer = this.ElRef.nativeElement.querySelector('#conversation-container');
    }

    /**
     * verifica se ouve alguma alteração no container das msgs e executa o scroll
     * 
     * @return MutationObserver
     */
    containerScrollObserver() {
        return new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                setTimeout(() => {
                    Array.from(mutation.addedNodes).map((elMutatation: any) => {
                        this.ElRef.nativeElement.scrollTop = this.conversationContainer.offsetTop + this.conversationContainer.offsetHeight;
                    });
                }, 300);
            });
        });
    }

    // verifica se a ultima msg foi do assessor ou do usuario 
    checkParent() {
        if (this.ContainerAgentTyping && this.ContainerAgentTyping.previousElementSibling) {
            switch (this.ContainerAgentTyping.previousElementSibling.nodeName) {
                case 'ASSESSOR-MESSAGE-RENDER':
                    this._r.addClass(this.ContainerAgentTyping, 'text-sequence');
                    break;
                case 'USER-MESSAGE-RENDER':
                    this._r.removeClass(this.ContainerAgentTyping, 'text-sequence');
                    break;
            }
        }
    }

    // gerencia os custom events que alteram o DOM
    managementCustomEvents() {
        switch (this.customEvent.type) {
            // "type": "assessorPicture",
            case 'assessorPicture':
                // "data": "{\"urlPhoto\":\"https://toroctvm--torodev--c.cs68.content.force.com/servlet/servlet.ImageServer?id=0151D0000005N7F&oid=00D1D0000008tP5&lastMod=1521055862000\"}"
                
                let dataParse = JSON.parse(this.customEvent.data);
                
                this.ElRef.nativeElement.insertAdjacentHTML('beforeend', '<style>.chat-message-item.agent-talk:before{background: none !important;}</style>');
                break;
            default:
                
                break;
        }
    }
}